/**
 * The customer page's tab axis, as data.
 *
 * React-free on purpose, so the rule can be tested without mounting a page
 * that pulls in Leaflet. Same reason `sites/location/tabs.ts` exists.
 */

/**
 * Every tab the customer page can render a body for.
 *
 * `?tab=` came straight off the query string with `?? "overview"` — which
 * defends against MISSING but not against WRONG. A link carrying
 * `?tab=locations ` (trailing space), a renamed tab from an old bookmark, or
 * anything else not in this list rendered the page chrome over an EMPTY body:
 * no tab highlighted, no content, no error. The page looked broken and there
 * was nothing on screen to say why.
 *
 * Three of these are conditional in the strip (routing, billing, rules). They stay
 * valid here on purpose — landing on a tab you cannot currently see is a
 * blank body for a different reason, and the fix for that is the strip, not
 * the URL parser.
 */
const CUSTOMER_TABS = [
    "overview",
    "locations",
    "jobs",
    "work-orders",
    "estimates",
    "invoices",
    "contacts",
    "routing",
    "rules",
    "agreements",
    "billing",
    "budget",
    "calls",
    "activity",
] as const;

export type CustomerTabId = (typeof CUSTOMER_TABS)[number];

export function parseCustomerTab(raw: string | null | undefined): CustomerTabId {
    const v = raw?.trim();
    return (CUSTOMER_TABS as ReadonlyArray<string>).includes(v ?? "") ? (v as CustomerTabId) : "overview";
}
